export default {
  GET_INSTRUMENT_CATEGORIES: state => state.instrumentCategories,
  GET_INSTRUMENTS_MODEL: state => state.instrumentsStateModel,
  GET_INSTRUMENTS_MODEL_VARIANT: state => state.instrumentsStateModelVariant,
  GET_INSTRUMENTS_FOR_ENTERING: state => state.instrumentsForEntering,
  GET_ISNTRUMENTS_REMAINS: state => state.instrumentRemains,
  GET_ISNTRUMENTS_MODAL_DETAIL: state => state.instrumentModalDetails,


  GET_ISNTRUMENTS_REMAINS_BUILDERS: state => state.instrument_for_builds,
}
